import styled from "styled-components";
import React from "react";
import { fa1, fa2, fa3, fa4 } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { mensaje } from "./WhatsappBTN";

const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  width: 250px;
  gap: 20px;
  padding: 30px 0px;
  border-radius: 20px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  background-color: var(--white);
  cursor: pointer;
  transition: 0.2s all ease-out;
  svg {
    color: var(--red);
    height: 50px;
  }
  &:hover {
    box-shadow: var(--red) 0px 2px 8px 0px;
    transform: scale(1.05);
    transition: 0.2s all ease-in;
  }

  @media (max-width: 1250px) {
    width: 220px;
    padding: 30px 0px 20px 0px;
    gap: 10px;
  }
  @media (max-width: 992px) {
    width: 250px;
    gap: 20px;
    padding: 30px 0px;
  }
  @media (max-width: 576px) {
    width: 300px;
    padding: 60px 0px;
    svg {
      height: 65px;
    }
  }
`;

const ExternalCard = styled.a`
  display: flex;
  flex-direction: column;
  width: 250px;
  gap: 20px;
  padding: 30px 0px;
  border-radius: 20px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  background-color: var(--white);
  cursor: pointer;
  transition: 0.2s all ease-out;
  svg {
    color: var(--red);
    height: 50px;
  }
  &:hover {
    box-shadow: var(--red) 0px 2px 8px 0px;
    transform: scale(1.05);
    transition: 0.2s all ease-in;
  }

  @media (max-width: 1250px) {
    width: 220px;
    padding: 30px 0px 20px 0px;
    gap: 10px;
  }
  @media (max-width: 992px) {
    width: 250px;
    gap: 20px;
    padding: 30px 0px;
  }
  @media (max-width: 576px) {
    width: 300px;
    padding: 60px 0px;
    svg {
      height: 65px;
    }
  }
`;

const CardsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 40px;
  margin-bottom: 30px;
`;

const CardTitle = styled.h3`
  color: var(--black);
  font-family: var(--raleway);
  font-size: 1.2rem;
  font-weight: 700;
  text-align: center;
  @media (max-width: 576px) {
    font-size: 1.4rem;
  }
`;

const Paragraph = styled.p`
  color: var(--black);
  font-size: 0.9rem;
  font-weight: 300;
  text-align: center;
  font-family: var(--roboto);
  text-align: center;
  padding: 0px 30px;
  @media (max-width: 576px) {
    font-size: 1.1rem;
  }
`;

const HowTo = () => {
  return (
    <>
      <CardsContainer data-aos="fade-right">
        <ExternalCard
          href={`https://wa.me/541130710101?text=${mensaje}`}
          target={"_blank"}
        >
          <FontAwesomeIcon icon={fa1} />
          <CardTitle>Asesorate</CardTitle>
          <Paragraph>
            Recibí asesoría para el alquiler de los vehículos con nuestros
            expertos.
          </Paragraph>
        </ExternalCard>
        <Card to={"/flota"}>
          <FontAwesomeIcon icon={fa2} />
          <CardTitle>Elegí</CardTitle>
          <Paragraph>
            Escoge el vehículo de tu preferencia disponible en nuestro catálogo.
          </Paragraph>
        </Card>
        <ExternalCard href={`/pdf/prueba.pdf`} target={"_blank"}>
          <FontAwesomeIcon icon={fa3} />
          <CardTitle>Tramitá</CardTitle>
          <Paragraph>
            Te ayudamos a realizar el trámite de aprobación y evacuamos tus
            dudas acerca de los requisitos necesarios.
          </Paragraph>
        </ExternalCard>
        <ExternalCard
          href="https://www.instagram.com/realcarsalquiler/"
          target={"_blank"}
        >
          <FontAwesomeIcon icon={fa4} />
          <CardTitle>¡A Disfrutar!</CardTitle>
          <Paragraph>
            Vivi tu experiencia, aprovecha de los beneficios de te ofrece, y
            déjanos tu comentario en nuestras redes sociales.
          </Paragraph>
        </ExternalCard>
      </CardsContainer>
    </>
  );
};

export default HowTo;
